export default __webpack_public_path__ + "static/connections-82ad5b465f49e291f53c8edfa74216f4.png";